module.exports = __webpack_public_path__ + "img/10_72.205968c8.png";